import { Crown } from "lucide-react";
import { cn } from "@/lib/utils";

export function SubscriptionBanner({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "sub-banner-glow group relative w-full overflow-hidden rounded-2xl border border-[var(--primary-glow)]/40",
        "bg-[var(--background)]/90 px-4 py-3 backdrop-blur-xl",
        "transition-all hover:brightness-110 active:scale-[0.99]",
      )}
    >
      <style>{`@keyframes subGlow{0%,100%{box-shadow:0 0 0 1px rgba(103,232,249,.35),0 0 14px -2px rgba(34,211,238,.45),0 0 26px -8px rgba(74,222,128,.4)}50%{box-shadow:0 0 0 1px rgba(186,250,255,.6),0 0 22px 0 rgba(34,211,238,.6),0 0 40px -6px rgba(74,222,128,.5)}}.sub-banner-glow{animation:subGlow 2.8s ease-in-out infinite}@media (prefers-reduced-motion:reduce){.sub-banner-glow{animation:none;box-shadow:0 0 0 1px rgba(103,232,249,.4),0 0 18px -2px rgba(34,211,238,.5)}}`}</style>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[var(--primary)]/25 via-transparent to-[var(--primary-glow)]/10"
      />
      <div className="relative flex items-center gap-3">
        <span
          className={cn(
            "grid size-10 shrink-0 place-items-center rounded-full",
            "bg-gradient-to-br from-[var(--primary)] to-[var(--primary-glow)]",
            "shadow-[0_0_16px_-4px_rgba(111,174,53,0.6)]",
          )}
        >
          <Crown className="size-5 text-white" />
        </span>
        <div className="min-w-0 flex-1 text-left">
          <p className="text-[13px] font-bold text-[var(--foreground)]">Get Quantum Minds Subscription</p>
        </div>
        <span className="shrink-0 text-[12px] font-semibold text-primary transition-transform group-hover:translate-x-0.5">
          Tap to know more →
        </span>
      </div>
    </button>
  );
}
